import { render, staticRenderFns } from "./ResetPassword2.vue?vue&type=template&id=2221e88c&"
import script from "./ResetPassword2.vue?vue&type=script&lang=js&"
export * from "./ResetPassword2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports